module.exports = __webpack_public_path__ + "static/media/add-logo-mobile-en.31a05702.webp";